var map = {
	"./MusicMaps.png": 515,
	"./TortlePoll.PNG": 667,
	"./falling block game image.jpg": 567,
	"./minesweeper-image.png": 673,
	"./moodify.png": 620,
	"./pancake-bot.PNG": 531,
	"./ring-detection.png": 409
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 482;